import { ScopePlanned } from '../../../../consts/scopePlanned';
import { ImageryGeolocationalAccuracy } from '../../../../consts/ImageryGeolocationalAccuracy';
import { UploadType } from '../../../../consts/uploadType';
import { GeorefData } from '../../../../store/uploadStore';

/**
 * The Scope: Planned field is a mess, we've discussed with Ivan and came up with this temporary solution to determine
 * the mission type. If OPS ask, we will need to come up with a more comprehensive formula and have "RTK/Regular", "PPK",
 * and "LiDAR" missions based on Scope + Geolocational Accuracy.
 * @param scope
 */
export const determineIfScopeIsScan = (scope: ScopePlanned | null | undefined) => {
  return (
    !scope ||
    [
      ScopePlanned.Advanced,
      ScopePlanned.AdvancedHighResolution,
      ScopePlanned.Basic,
      ScopePlanned.BasicHighResolution,
      ScopePlanned.BasicForTAOnly,
      ScopePlanned.LiDAR,
    ].includes(scope as ScopePlanned)
  );
};

export const determineIfScopeIsPanoOnly = (scope: ScopePlanned | null | undefined) => scope === ScopePlanned.PanoOnly;

export const guessScanUploadType = (
  scope: ScopePlanned | null,
  geoAccuracies: ImageryGeolocationalAccuracy[] | null,
  georef: GeorefData | undefined,
) => {
  if (georef) {
    return UploadType.Ppk;
  }

  if (!scope) {
    return UploadType.RegularAndRtk;
  }

  if (scope === ScopePlanned.LiDAR) {
    return UploadType.Lidar;
  }

  const geoAccuracy = geoAccuracies?.[0];
  return geoAccuracy === ImageryGeolocationalAccuracy.Ppk ? UploadType.Ppk : UploadType.RegularAndRtk;
};
